var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlock1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3387 1.73849C10.1233 1.64272 9.87733 1.64272 9.66191 1.73849L2.1655 5.07021C2.12442 5.08824 2.08452 5.10971 2.04623 5.13459C1.8097 5.28831 1.66699 5.55125 1.66699 5.83333V14.1667C1.66699 14.496 1.86093 14.7944 2.16188 14.9282L9.66191 18.2615C9.87733 18.3572 10.1233 18.3572 10.3387 18.2615L17.8387 14.9282C18.1397 14.7944 18.3337 14.496 18.3337 14.1667V5.83333C18.3337 5.55125 18.1909 5.28831 17.9544 5.13459C17.916 5.10961 17.8759 5.08806 17.8347 5.06999L10.3387 1.73849ZM15.4485 5.83333L10.0003 3.41193L4.55217 5.83333L10.0003 8.25474L15.4485 5.83333Z",
    fill: "#D42124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock1);
export default __webpack_public_path__ + "static/media/block1.3b00eedd6c2d687871245ae77ae01196.svg";
export { ForwardRef as ReactComponent };